import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { Link } from 'react-router-dom';

import Brand from 'models/brand';
import { PressRelease as PressReleaseModel } from 'models/press-release';

const propTypes = {
  pressRelease: PropTypes.instanceOf(PressReleaseModel).isRequired,
  brand: PropTypes.instanceOf(Brand).isRequired,
};

const defaultProps = {
};

const PressRelease = ({ pressRelease, brand }) => (
  <div className="background-image-smooth-p-gradient padding-top-xs-80 padding-top-md-120 margin-bottom-xs-40">
    <div className="container text-center">
      <a href="/" className="hidden-xs hidden-sm header-logo-dark">
        <img src={brand.logoLightURL} alt={brand.displayName} />
      </a>
      <div className="row visible-xs visible-sm">
        <div className="col-sm-6 col-sm-offset-3 col-xs-8 col-xs-offset-2 margin-top-negative-60">
          <a href="/">
            <picture>
              <img src={brand.logoLightURL} alt={brand.displayName} />
            </picture>
          </a>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-10 col-sm-offset-1 text-align-left">
          <span className="iconified-font iconified-thin-chevron-left">
            <Link
              to={{ pathname: '/about/press' }}
              className="padding-left-10 text-weight-bold text-size-sm-16 text-size-xs-14 text-color-blue"
            >Back to Press Page</Link>
          </span>
        </div>
      </div>
      <div className="row">
        <div className="flair-bottom-left-two-dash col-sm-10 col-sm-offset-1 text-size-sm-42 text-size-xs-24 text-weight-black text-color-dark-slate padding-top-xs-10 padding-top-sm-30 padding-bottom-sm-40 padding-bottom-xs-20 margin-bottom-20 text-align-sm-left text-align-xs-center">
          {pressRelease.title}
        </div>
      </div>
      <div className="row hidden-xs">
        <div className="col-sm-10 col-sm-offset-1 text-size-sm-24 text-weight-bold text-color-dark-slate padding-top-sm-30 padding-bottom-sm-40 text-align-left">
          {pressRelease.leadLine}
        </div>
      </div>
      <div className="row">
        <div className="col-sm-10 col-sm-offset-1 padding-bottom-10 text-align-left">
          <ReactMarkdown
            source={pressRelease.body}
            className="text-weight-book text-size-sm-16 text-size-xs-14 text-color-dark-slate"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-10 col-sm-offset-1 text-align-left">
          <span className="iconified-font iconified-thin-chevron-left">
            <Link
              to={{ pathname: '/about/press' }}
              className="padding-left-10 text-weight-bold text-size-sm-16 text-size-xs-14 text-color-blue"
            >Back to Press Page</Link>
          </span>
        </div>
      </div>
    </div>
  </div>
);

PressRelease.propTypes = propTypes;
PressRelease.defaultProps = defaultProps;
export default PressRelease;
